import { render } from "./EducationTable.vue?vue&type=template&id=9f969c18&scoped=true"
import script from "./EducationTable.vue?vue&type=script&lang=js"
export * from "./EducationTable.vue?vue&type=script&lang=js"

import "./EducationTable.vue?vue&type=style&index=0&id=9f969c18&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f969c18"]])

export default __exports__